import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { api } from "../lib/api";

export function FloatingContact() {
  const [phone, setPhone] = useState("");

  useEffect(() => {
    api.get("/content").then((r) => setPhone(r.data.contact_phone || "")).catch(() => {});
  }, []);

  const digits = phone.replace(/[^\d]/g, "").replace(/^0/, "40");
  if (!digits) return null;

  return (
    <motion.a
      href={`https://wa.me/${digits}`}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.5, type: "spring", stiffness: 200, damping: 16 }}
      className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-navy text-white shadow-lg shadow-navy/30 transition-colors hover:bg-navy-dark"
      aria-label="Scrie-ne pe WhatsApp"
      data-testid="floating-contact-button"
    >
      <MessageCircle className="h-6 w-6" />
    </motion.a>
  );
}
